import React from 'react'
import {FaFacebookF} from 'react-icons/fa'
import {FiInstagram} from 'react-icons/fi'
import {IoLogoTwitter} from 'react-icons/io'
import {SiDiscord} from 'react-icons/si'

import './footer.css'

const Footer = () => {
  return (
    <footer>
      <a href="#" className='footer_logo' >SUBHANGAM DEY</a>
        <ul className='permalinks'>
            <li><a href="#">Home</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#experience">Experience</a></li>
            <li><a href="#portfolio">Portfolio</a></li>
            <li><a href="#contact">Contact</a></li>
        </ul>
            <div className="footer_socials">
            <a href="https://www.facebook.com/subhangam.dey"><FaFacebookF/></a>
            <a href="https://instagram.com"><FiInstagram/></a>
            <a href="https://discordapp.com/users/subhangam03"><SiDiscord /></a>
            </div>
    </footer>
  )
}

export default Footer